import Vue from 'vue'
import { SIGNALR_MIXIN_PARAMS } from '@/constants/signalR'

// eventsList - список объектов с именами событий и методов, запускаемых при этих событиях
// {eventName, - наименование события
// callbackName - наименование метода, запускаемого при указанном выше событии}
// invokeList - список объектов с параметрами методов, которые запускаются после подключения к хабу
// {methodName, - наименование метода, которые запускаются после подключения к хабу
// getGroupNameMethod - наименование метода, который получает имя группы для подключение пользователя}
const signalRMixin = (params = {}) => {
  const getHubMethodName = params[SIGNALR_MIXIN_PARAMS.GET_HUB_METHOD_NAME]
  const eventsList = params[SIGNALR_MIXIN_PARAMS.EVENTS_LIST]
  const invokeList = params[SIGNALR_MIXIN_PARAMS.INVOKE_LIST]
  const reconnectCallbackName = params[SIGNALR_MIXIN_PARAMS.RECONNECT_CALLBACK_NAME]
  return {
    data () {
      return {
        connected: false,
        connection: null
      }
    },
    computed: {
      signalREventsList () {
        // список событий для создания подписок
        return eventsList.map(e => ({
          eventName: e[SIGNALR_MIXIN_PARAMS.EVENT_NAME],
          // получаем метод по имени из текущего компонента
          callback: this[e[SIGNALR_MIXIN_PARAMS.CALLBACK_NAME]]
        }))
      },
      signalRInvokeList () {
        // список методов, для вызова при успешном подключении к хабу
        return invokeList.map(i => ({
          methodName: i[SIGNALR_MIXIN_PARAMS.METHOD_NAME],
          // получаем метод по имени из текущего компонента
          groupName: this[i[SIGNALR_MIXIN_PARAMS.GET_GROUP_NAME_METHOD]] || null
        }))
      }
    },
    watch: {
      connected (newVal, oldVal) {
        if (newVal && !oldVal && reconnectCallbackName) {
          this[reconnectCallbackName]()
        }
      }
    },
    created () {
      if (!eventsList) {
        // eslint-disable-next-line no-console
        console.error('Отсутствует список событий для конфигурирования подключения.')
        this.showErrorAction({
          message: this.$t('Отсутствует список событий для конфигурирования подключения.')
        })
        return
      }
      if (!invokeList) {
        // eslint-disable-next-line no-console
        console.error('Отсутствует список методов подключения к группе рассылок.')
        this.showErrorAction({
          message: this.$t('Отсутствует список методов подключения к группе рассылок.')
        })
        return
      }
      if (!this[getHubMethodName]()) {
        console.error('Не определен хаб для подключения.')
        this.showErrorAction({
          message: this.$t('Не определен хаб для подключения.')
        })
      }
      this.configurateSignalRConnection()
    },
    beforeDestroy () {
      const vm = this
      if (vm.connection) {
        vm.signalREventsList.forEach(event => {
          if (vm.connection) {
            vm.connection.off(event.eventName)
          }
        })
        vm.connection.stop()
        vm.connection = null
      }
    },
    methods: {
    // конфигурирование подключения к хабу signalR
      configurateSignalRConnection: function () {
      // https://docs.microsoft.com/ru-ru/aspnet/core/signalr/configuration?view=aspnetcore-3.1&tabs=dotnet

        const vm = this
        vm.connection = new vm.$signalR.HubConnectionBuilder()
          .withUrl(Vue.getSignalRHost() + vm[getHubMethodName](), {
            accessTokenFactory: () => {
            // Get and return the access token.
              return vm.token
            }
          })
          .configureLogging(vm.$signalR.LogLevel.Error)
          .build()
        if (vm.signalREventsList.length) {
          vm.signalREventsList.forEach(event => {
            vm.connection.on(event.eventName, event.callback)
          })
        }
        vm.connection.onreconnecting((error) => {
          vm.checkConnectionStatus()
          if (vm.isTestMode && error) {
          //  console.log(error)
          }
        })
        vm.connection.onreconnected((connectionId) => {
          vm.checkConnectionStatus()
          if (vm.isTestMode) {
          // console.log(`reconnected id: ${connectionId}`)
          }
        })
        vm.connection.onclose(async () => {
          vm.checkConnectionStatus()
          await vm.startSignalR()
        })
      },
      // открываем подключение к хабу signalR
      startSignalR: async function () {
        const vm = this
        if (!vm.connection) {
          return
        }
        try {
          if (vm.connection.state === vm.$signalR.HubConnectionState.Disconnected) {
            await vm.connection.start()
            if (vm.isTestMode) {
              // eslint-disable-next-line no-console
              console.log('connected')
            }
            vm.checkConnectionStatus()
          }
          if (vm.connected) {
            await vm.invokeServerMethods()
          }
        } catch (error) {
          if (vm.isTestMode) {
            // eslint-disable-next-line no-console
            console.error(error)
          }
          vm.checkConnectionStatus()
          setTimeout(async () => {
            await vm.startSignalR()
          }, 5000)
        }
      },
      invokeServerMethods: async function () {
        const vm = this
        await Promise.all(vm.signalRInvokeList.map(i => {
          if (vm.isTestMode) {
            // eslint-disable-next-line no-console
            console.log(`${i.methodName}: ${i.groupName ? i.groupName() : 'without params'}`)
          }
          if (i.groupName) {
            return vm.connection.invoke(i.methodName, i.groupName())
          } else {
            return vm.connection.invoke(i.methodName)
          }
        }))
      },
      checkConnectionStatus: function () {
        const isConnected = !!this.connection &&
        this.connection.state === this.$signalR.HubConnectionState.Connected
        if (!!this.connection && this.isTestMode) {
          console.log(this.connection.state)
        }
        if (this.connected !== isConnected) {
          this.connected = isConnected
        }
      }
    }
  }
}

export default signalRMixin
